<template>
  <div class="list" v-show="position.show">
    <div
      v-for="n in 2"
      :key="n"
      :style="{
        '--positionTop': `-${height || position.h - 2}px`,
        '--positionLeft': `-${width || position.w - 2}px`,
        '--translateY': `-${height || position.h - 2}px`,
        '--translateX': `${width || position.w - 2}px`
      }"
      ref="roll"
    >
      <table
        class="table"
        ref="table"
        :style="{
          width: `${width || position.w - 2}px`,
          height: `${height || position.h - 2}px`,
          borderCollapse: 'collapse',
          tableLayout: 'fixed'
        }"
      >
        <tr v-for="row in option.rows" :key="row" :style="rowStyle(row, option.rows)">
          <td v-for="col in option.columns" :key="col" :style="colStyle(col, option.columns)">
            <span style="display: inline-block; margin-left: 0px;">{{ handleTableData(row, col) }}</span>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      width: null,
      height: null,
      borderVisibleStyle: {}, // 边框可见性样式
      timer: '' // 动画效果重绘
    }
  },
  props: {
    option: {
      type: Object,
      default: null
    },
    position: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    tableData() {
      let data = []
      try {
        data = this.option.data
      } catch (error) {
        // TODO 重复调用问题 用css样式解决
        // return this.$message.warn('数据格式错误')
      }
      return data
    },
    // 切换动画效果
    animationOption() {
      return this.option.animationOption
    }
  },
  methods: {
    /**
     * 表格行样式渲染
     * row:当前行数 length:总行数
     */
    rowStyle(row, length) {
      const rowStyleObj = {}
      /**
       * bgOption 背景颜色统一或自定义选择 1:统一背景色 2:自定义
       * bgRocOption 背景颜色行列选择 1:行背景色 2:列背景色
       */
      if (this.option.bgOption === 2 && this.option.bgRocOption === 1) {
        // 渲染行背景色
        if (row === 1) {
          // 首行
          rowStyleObj.background = this.option.style.tr.background.first
        } else if (row === length) {
          // 末行
          rowStyleObj.background = this.option.style.tr.background.last
        } else if (row % 2 === 0) {
          // 偶数行
          rowStyleObj.background = this.option.style.tr.background.even
        } else if (row % 2 !== 0) {
          // 奇数行
          rowStyleObj.background = this.option.style.tr.background.odd
        }
      }
      // 根据行渲染文字样式
      if (this.option.fontRocOption === 1) {
        if (row === 1) {
          rowStyleObj.color = this.option.style.tr.color.first
          rowStyleObj.fontSize = `${this.option.style.tr.fontSize.first}px`
          rowStyleObj.fontFamily = this.option.style.tr.fontFamily.first
          rowStyleObj.textAlign = this.option.style.tr.textAlign.first
        } else {
          rowStyleObj.color = this.option.style.tr.color.other
          rowStyleObj.fontSize = `${this.option.style.tr.fontSize.other}px`
          rowStyleObj.fontFamily = this.option.style.tr.fontFamily.other
          rowStyleObj.textAlign = this.option.style.tr.textAlign.other
        }
      }
      return rowStyleObj
    },
    /**
     * 表格列样式渲染
     * row:当前行数 col:当前列数 rowLength:总行数 colLength:总列数
     */
    colStyle(col, colLength) {
      const colStyleObj = {}
      /**
       * 基本参数样式渲染
       */
      colStyleObj.borderColor = this.option.style.td.borderColor
      colStyleObj.borderWidth = `${this.option.style.td.borderWidth}px`
      colStyleObj.borderStyle = this.option.style.td.borderStyle
      // 设置全局背景色
      if (this.option.bgOption === 1) {
        colStyleObj.background = this.option.style.table.background
      }
      /**
       * 动态参数配置渲染
       */
      // 根据边框可见性配置渲染边框
      switch (this.option.borderVisible) {
        case 1: // 全部
          colStyleObj.borderWidth = `${this.option.style.td.borderWidth}px`
          break
        case 2: // 横向
          colStyleObj.borderWidth = `${this.option.style.td.borderWidth}px 0`
          break
        case 3: // 纵向
          colStyleObj.borderWidth = `0 ${this.option.style.td.borderWidth}px`
          break
        case 4: // 无边框
          colStyleObj.borderWidth = '0'
          break
      }
      // 根据列渲染背景色
      if (this.option.bgOption === 2 && this.option.bgRocOption === 2) {
        if (col === 1) {
          // 首行
          colStyleObj.background = this.option.style.td.background.first
        } else if (col === colLength) {
          // 末行
          colStyleObj.background = this.option.style.td.background.last
        } else if (col % 2 === 0) {
          // 偶数行
          colStyleObj.background = this.option.style.td.background.even
        } else if (col % 2 !== 0) {
          // 奇数行
          colStyleObj.background = this.option.style.td.background.odd
        }
      }
      // 根据列渲染文字样式
      if (this.option.fontRocOption === 2) {
        colStyleObj.color = this.option.style.td.color[col - 1].first
        colStyleObj.fontSize = `${this.option.style.td.fontSize[col - 1].first}px`
        colStyleObj.fontFamily = this.option.style.td.fontFamily[col - 1].first
        colStyleObj.textAlign = this.option.style.td.textAlign[col - 1].first
      }
      return colStyleObj
    },
    // 表格数据
    handleTableData(row, col) {
      let data
      if (row <= this.tableData.length && col <= this.tableData[row - 1].length) {
        data = this.tableData[row - 1][col - 1]
      } else {
        data = ''
      }
      return data
    },
    // 动态切换动画效果
    animationChange(val) {
      this.$refs.roll[0].className = ''
      this.$refs.roll[1].className = ''
      if (this.timer) {
        clearTimeout(this.timer)
      }
      // 延迟500ms使计算后的偏移值改变后更新动画效果
      this.timer = setTimeout(() => {
        this.$refs.roll[0].className = ['', 'roll-right', 'roll-up'][val]
        this.$refs.roll[1].className = ['', 'roll-right tanslate', 'roll-up'][val]
      }, 500)
    },
    // 重绘大小
    resize(w, h) {
      this.width = w - 2
      this.height = h - 2
      this.height = this.height > this.$refs.table[0].clientHeight ? this.height : this.$refs.table[0].clientHeight + 2
      this.animationChange(this.animationOption)
    }
  },
  mounted() {
    // 初始化加载动画效果
    this.$refs.roll[0].className = ['', 'roll-right', 'roll-up'][this.animationOption]
    this.$refs.roll[1].className = ['', 'roll-right tanslate', 'roll-up'][this.animationOption]
  },
  watch: {
    animationOption(val) {
      this.animationChange(val)
    }
  }
}
</script>

<style lang="less" scoped>
.list {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.table td {
  white-space: nowrap;
  overflow: hidden;
}
.roll-up {
  -webkit-animation: 5s rollUp linear infinite normal;
  animation: 5s rollUp linear infinite normal;
  position: relative;
}
@keyframes rollUp {
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  100% {
    -webkit-transform: translate3d(0, var(--translateY), 0);
    transform: translate3d(0, var(--translateY), 0);
  }
}
.roll-right {
  -webkit-animation: 5s rollRight linear infinite normal;
  animation: 5s rollRight linear infinite normal;
  position: relative;
}
.tanslate {
  top: var(--positionTop);
  left: var(--positionLeft);
}
@keyframes rollRight {
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  100% {
    -webkit-transform: translate3d(var(--translateX), 0, 0);
    transform: translate3d(var(--translateX), 0, 0);
  }
}
</style>
